module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "room"
  }, [_c('div', {
    staticClass: "roomTitle"
  }, [_vm._v("\n        " + _vm._s(_vm.room.title) + "\n\n        "), (_vm.currentMonth && _vm.isClean !== null) ? _c('span', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.top-center",
      value: (_vm.cleaningStatus),
      expression: "cleaningStatus",
      modifiers: {
        "top-center": true
      }
    }],
    staticClass: "fa fa-info-circle fa-fw pull-right status",
    class: {
      cleaned: _vm.isClean
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "days"
  }, _vm._l((_vm.daysInMonth), function(i) {
    return _c('div', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip",
        value: ((_vm.matchedReservations[i]) ? _vm.matchedReservations[i].name : null),
        expression: "(matchedReservations[i]) ? matchedReservations[i].name : null"
      }],
      staticClass: "navigatable",
      class: {
        today: _vm.currentMonth && i === _vm.today.day(),
          reserved: _vm.matchedReservations[i] !== null && _vm.matchedReservations[i] !== undefined,
          first: _vm.isFirst(i, _vm.matchedReservations[i]),
          last: _vm.isLast(i, _vm.matchedReservations[i]), isPaid: (_vm.matchedReservations[i] && _vm.matchedReservations[i].paid),
          grouped: (_vm.matchedReservations[i] && _vm.groupedReservations[_vm.matchedReservations[i].id])
      },
      on: {
        "click": function($event) {
          return _vm.select(i)
        }
      }
    }, [(i < 10) ? [_vm._v("0")] : _vm._e(), _vm._v(_vm._s(i) + "\n        ")], 2)
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3fdd1fc6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/calendar/Room.vue
// module id = 392
// module chunks = 1